import * as XLSX from 'xlsx';

export interface ImportUserRow {
  username: string;
  email: string;
  password: string;
}

export function downloadUserImportTemplate() {
  const wb = XLSX.utils.book_new();
  const data = [
    ['用户名', '邮箱', '密码'],
    ['张三', 'zhangsan@example.com', 'Pass1234'],
    ['李四', 'lisi@example.com', 'Pass5678'],
  ];
  const ws = XLSX.utils.aoa_to_sheet(data);
  ws['!cols'] = [{ wch: 15 }, { wch: 28 }, { wch: 15 }];
  XLSX.utils.book_append_sheet(wb, ws, '用户导入');
  XLSX.writeFile(wb, '用户导入示例.xlsx');
}

export async function parseUserImportFile(file: File): Promise<ImportUserRow[]> {
  const buffer = await file.arrayBuffer();
  const wb = XLSX.read(buffer, { type: 'array' });
  const sheet = wb.Sheets[wb.SheetNames[0]];
  const rows = XLSX.utils.sheet_to_json<string[]>(sheet, { header: 1, defval: '' }) as string[][];

  if (rows.length < 2) {
    throw new Error('Excel 文件无有效数据行');
  }

  const header = rows[0].map((h) => String(h).trim());
  const usernameIdx = header.findIndex((h) => h === '用户名' || h.toLowerCase() === 'username');
  const emailIdx = header.findIndex((h) => h === '邮箱' || h.toLowerCase() === 'email');
  const passwordIdx = header.findIndex((h) => h === '密码' || h.toLowerCase() === 'password');

  if (usernameIdx < 0 || emailIdx < 0 || passwordIdx < 0) {
    throw new Error('表头需包含：用户名、邮箱、密码');
  }

  const users: ImportUserRow[] = [];
  for (let i = 1; i < rows.length; i++) {
    const row = rows[i];
    const username = String(row[usernameIdx] ?? '').trim();
    const email = String(row[emailIdx] ?? '').trim();
    const password = String(row[passwordIdx] ?? '').trim();
    if (!username && !email && !password) continue;
    users.push({ username, email, password });
  }

  if (users.length === 0) {
    throw new Error('未解析到有效用户数据');
  }

  return users;
}
